import { functions } from "../services/firebase/firebaseInit";
import { httpsCallable } from "@firebase/functions";

// Espelha voki-backend/functions/src/models/whatsappBotConfig.model.ts —
// mesmo princípio da URA de voz (fila é referência por queueId, erro herda
// do ancestral mais próximo), mas message/error são texto puro, não áudio.
export type WhatsappBotError = string | { type: "queue"; queueId: string };

export interface WhatsappBotMenuNode {
  message: string;
  error?: WhatsappBotError;
  options: WhatsappBotMenuOption[];
}

export type WhatsappBotMenuOption = {
  option: number;
  name: string;
  // Opcional — mensagem enviada ao contato assim que ele escolhe esta
  // opção, antes de continuar o fluxo (fila ou submenu). Pra destino
  // "queue", substitui o texto fixo de encaminhamento (não manda os
  // dois); pra "submenu", é enviada antes da mensagem do próprio nó.
  confirmationMessage?: string;
} & (
  | { type: "queue"; queueId: string }
  | { type: "submenu"; node: WhatsappBotMenuNode }
);

export interface WhatsappBotConfig {
  enabled: boolean;
  fallbackQueueId: string;
  root: WhatsappBotMenuNode;
  // Opcional e desligado por padrão — controla o desvio "fora do horário
  // de atendimento", independente do bot de menu (`enabled` acima) estar
  // ligado. Usa o mesmo horário já configurado na tela de Horário de
  // Atendimento (telefonia), não duplica config — só decide o que fazer
  // quando ele diz "fechado".
  afterHours?: WhatsappBotAfterHoursConfig;
  // Opcional e desligado por padrão, mesmo princípio de afterHours acima —
  // encerra/encaminha sozinha uma conversa presa no bot (contato nunca
  // escolheu uma opção válida) depois de tempo sem nenhuma mensagem NOVA
  // do bot. Não afeta conversa já em fila/atendimento.
  expiration?: WhatsappBotExpirationConfig;
}

export interface WhatsappBotAfterHoursConfig {
  enabled: boolean;
  awayMessage: string;
  // false = só responde a mensagem automática, não cria/roteia a conversa
  // pra fila. true = responde E direciona pra fila mesmo assim.
  routeToQueue: boolean;
}

export interface WhatsappBotExpirationConfig {
  enabled: boolean;
  // Horas desde a última mensagem do bot sem resposta válida.
  hours: number;
  message: string;
  // false = encerra o atendimento. true = encaminha pra fallbackQueueId em
  // vez de encerrar.
  routeToQueue: boolean;
}

type CallResult<T> = { error: boolean; data: T };

export async function getWhatsappBotConfig() {
  const fn = httpsCallable(functions, "getWhatsappBotConfig");
  const result = await fn({});
  return result.data as CallResult<WhatsappBotConfig | null>;
}

export async function saveWhatsappBotConfig(config: WhatsappBotConfig) {
  const fn = httpsCallable(functions, "saveWhatsappBotConfig");
  const result = await fn(config);
  return result.data as CallResult<{}>;
}
